import Cookies from 'js-cookie';

const { vin65 } = window;

export const mediumUp = 768;

export const init = () => { // eslint-disable-line import/prefer-default-export
  eventPolyfill();
  addButtonListener();
  addToCartListener();
  addCacheIFrame();
  closeModal();
  continueShopping();
  hideOptInCheckbox();
  hideOptInCheckboxOnError();
  removeEmptyTags();
  removeFieldsets();
  setInputTypes();
  checkoutToggleShipping();
};

const addButtonListener = () => {
  document.addEventListener('touchstart', () => {}, true);
};

const addToCartListener = () => {
  [...document.querySelectorAll('[v65js="addToCart"]')].forEach((form) => {
    form.addEventListener('submit', () => {
      Cookies.set('continueShoppingURL', window.location.href);
    }, false);
  });
};

const addCacheIFrame = () => {
  const cache = document.createElement('iframe');
  cache.src = '/cache.html';
  cache.style.cssText = 'width:0;height:0;border:0;display:none';
  document.body.appendChild(cache);
};

const continueShopping = () => {
  const continueShoppingURL = Cookies.get('continueShoppingURL');

  if (continueShoppingURL !== null) {
    const checkoutLinks = [...document.querySelectorAll('#v65-checkCartSummaryMoreOptions a')];
    checkoutLinks.forEach((checkoutLink) => {
      if (checkoutLink.textContent === 'Continue shopping') {
        checkoutLink.setAttribute('href', continueShoppingURL);
      }
    });

    const cartLinks = [...document.querySelectorAll('.v65-cartCheckOutButtons .linkAltBtn')];
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('href', continueShoppingURL);
    });
  }
};

const hideOptInCheckbox = () => {
  const optInCheckboxes = [...document.querySelectorAll('.newsletter-popup-wrapper div > input[name="isSingleOptIn"]')];
  optInCheckboxes.forEach((checkbox) => {
    checkbox.checked = true; // eslint-disable-line no-param-reassign
    checkbox.parentElement.style.display = 'none'; // eslint-disable-line no-param-reassign
  });
};

const hideOptInCheckboxOnError = () => {
  window.addEventListener('v65-formSubmission', hideOptInCheckbox, false);
};

const removeEmptyTags = () => {
  const elements = [...document.getElementsByTagName('p')];
  const productHeader = document.querySelector('.product-header h2');
  if (productHeader) {
    elements.push(productHeader);
  }

  elements.forEach((el) => {
    if (el.innerHTML.replace(/\s|&nbsp;|<!--.*-->/g, '').length === 0) {
      el.parentElement.removeChild(el);
    }
  });
};

const closeModal = () => {
  window.addEventListener('click', (e) => {
    if (e.target.id === 'v65-modalViel') {
      vin65.modal.closeWindow();
    }
  }, false);
};

const removeFieldsets = () => {
  const fieldsets = [...document.getElementsByTagName('fieldset')];
  fieldsets.forEach((fieldset) => {
    const parent = fieldset.parentElement;
    switch (true) {
      case parent.id === 'v65-checkBilling':
      case parent.parentElement.id === 'v65-checkBilling':
      case parent.parentElement.id === 'v65-memberFormWrapper':
        return false;
      default:
        break;
    }

    while (fieldset.firstChild) {
      fieldset.parentElement.insertBefore(fieldset.firstChild, fieldset);
    }
    fieldset.parentElement.removeChild(fieldset);
    return fieldset;
  });
};

const setInputTypes = () => {
  const inputs = [...document.getElementsByTagName('input')];
  inputs.forEach((input) => {
    const inputName = input.name.toLowerCase();
    switch (true) {
      case inputName.includes('email'):
        input.setAttribute('type', 'email');
        break;
      case inputName.includes('phone'):
      case inputName.includes('cardnumber'):
      case inputName.includes('quantity'):
        input.setAttribute('type', 'tel');
        break;
      default:
        return false;
    }

    return input;
  });
};

const checkoutToggleShipping = () => window.addEventListener('v65-reloadBillingElements', setInputTypes, false);

const eventPolyfill = () => {
  if (typeof window.CustomEvent === 'function') {
    return false;
  }

  function CustomEvent(event, params) {
    const eventParams = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
  return CustomEvent;
};

export const loadJS = (src, cb) => {
  const ref = window.document.getElementsByTagName('script')[0];
  const script = window.document.createElement('script');
  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore(script, ref);
  if (cb && typeof cb === 'function') {
    script.onload = cb;
  }
  return script;
};



// WEBPACK FOOTER //
// ./src/assets/js/general.js